export const meta = {
  title: "Schweizer Hotelsterne erklärt: Was '4-Sterne Superior' wirklich bedeutet",
  description: "Verwirrt von Hotelbewertungen? Erfahren Sie, was ein 4-Sterne Superior Hotel wie das Beatenberg Resort von Standardhotels unterscheidet.",
  date: "2024-04-05",
  image: "/images/gastroswiss_4_stern-320x320.jpg",
  author: "General Manager",
  category: "Insider Knowledge",
  keywords: ["hotelsterne schweiz", "4 sterne superior bedeutung", "hotel klassifizierung schweiz"]
}

# Schweizer Hotelsterne erklärt: Was '4-Sterne Superior' wirklich bedeutet

Die Schweiz hat das Konzept der Luxushotellerie erfunden. Das Bewertungssystem hier ist streng, transparent und wird von *HotellerieSuisse* durchgesetzt.

*Inhalt wird bald erweitert...*
